import { StandardEntity } from '../../engine/standard-entity';

export class FontAwesomeIcon extends StandardEntity {
  public tags: string[];

  constructor(id: string, label: string, tags: string[]) {
    super(id, label, 'full');
    this.tags = tags;
  }
}
